import { Card, CardContent, Grid, Skeleton, Stack } from '@mui/material';

export function RetentionLoadingState() {
  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid item xs={12} sm={6} lg={3} key={index}>
            <Card sx={{ borderRadius: 3 }}>
              <CardContent>
                <Skeleton width="45%" height={18} />
                <Skeleton width="60%" height={44} sx={{ mt: 1 }} />
                <Skeleton width="80%" height={18} sx={{ mt: 1 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} lg={7}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Skeleton width="38%" height={28} />
              <Skeleton
                variant="rectangular"
                height={280}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={5}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Skeleton width="58%" height={28} />
              <Skeleton
                variant="rectangular"
                height={280}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} lg={8}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Skeleton width="44%" height={28} />
              <Skeleton
                variant="rectangular"
                height={250}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Skeleton width="30%" height={28} />
              <Skeleton
                variant="rectangular"
                height={250}
                sx={{ mt: 2, borderRadius: 2 }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default RetentionLoadingState;
